export default "__VITE_ASSET__LoXEOXrJ__"